<div class="container main" >
    <div class="page-loader" *ngIf="loadershow">
        <img alt="" src="assets/images/uib-loading-500x5001.gif" style="width: 100px" />
    </div>
    <!-- Select Channel Type -->

    <div style="width: 80%;">
        <div class="uibIcon">
            <img alt="" src="assets/images/uib.png" style="width: 50px; padding-top: 10px;" />
        </div>
     <div class="box col-md-12 col-xs-12 "  >
        <div class="col-md-12 col-xs-12" style="display: flex; padding-bottom: 40px;padding-top: 20px;">
            <div class="col-md-12 col-xs-12" style="text-align: center; font-size: large; font-weight: bold;">
            <span style="margin-bottom:0px !important;">{{ 'WhatsppEmbedded.info' | translate }}</span>
            </div>
       </div>
            <section class="example-section">
                <p style="margin-top: 15px;margin-left: 2%;font-style: italic;">
                    {{ 'WhatsppEmbedded.info2' | translate }} <a href="https://www.facebook.com/business/help/2640149499569241" target="_blank"><b>here</b></a>.
                </p>
            </section>
            <form  [formGroup]="whatsappembeddedForm" > 
                <div class="form-group col-md-12 col-xs-12" style="display:inline-flex;padding:0px;">
                    <div class="form-group col-md-4 col-xs-4" style="display:block;margin:auto;text-align: left;">
                        <label>{{ 'WhatsppEmbedded.fbBusinessID' | translate }}</label>
                    </div>
                    <div class="col-md-7 col-xs-7" style="padding-right:0px;">
                        <input type="text" formControlName="embeddedManagerId" placeholder="Facebook Business Manager ID" class="form-control" [ngClass]="{ 'is-invalid':embeddedSubmitted && e.embeddedManagerId && e.embeddedManagerId.errors }"/>
                        <div *ngIf="embeddedSubmitted && e.embeddedManagerId && e.embeddedManagerId.errors" class="invalid-feedback">
                            <div *ngIf="e.embeddedManagerId.errors.required">{{ 'WhatsppEmbedded.fbIDRequired' | translate }}</div>
                            <div *ngIf="e.embeddedManagerId.errors.pattern">{{ 'WhatsppEmbedded.fbIDPattern' | translate }}</div>
                        </div>
                    </div>
                    <button type="button" class="col-md-1 col-xs-1 btn btn-default form-control headerTextEditorStyle" [popover]="managerIdTemplate" [placement]="'bottom'" [container]="'body'" [outsideClick]="true"> 
                        <em class="fas fa-info-circle"></em>
                    </button>
                  </div>

                    <div class="form-group col-md-12 col-xs-12" style="display:inline-flex;padding:0px;">
                <div class="form-group col-md-4 col-xs-4" style="display:block;margin:auto;text-align: left;">
                    <label>{{ 'WhatsppEmbedded.fblogo' | translate }}</label>
                </div>
                <div class="col-md-7 col-xs-7" style="padding-right:0px;display:inline-grid;">
                    <div style="display:inline-flex;">
                        <input type="file" placeholder="Company Logo" [ngClass]="{ 'is-invalid': embeddedSubmitted && e.embeddedLogo && e.embeddedLogo.errors }" accept="image/*" (change)="onFileEmbeddedChanged($event,'watsappEmbeddedlogo')" style="border:none;padding-left:0px;width:70%;">
                        <img alt="" [src]="responseImgEmbeddedURL" height="50" 
                            *ngIf="responseImgEmbeddedURL">
                        <img alt="" *ngIf="imageLoader && !responseImgEmbeddedURL" src="assets/images/uib-loading-500x500.gif" width="8%">
                    </div>
                    <!-- <div *ngIf="embeddedSubmitted" class="invalid-feedback2">
                        <div *ngIf="e.embeddedLogo && e.embeddedLogo.errors && e.embeddedLogo.errors.required">Company Logo is required</div>
                        <div *ngIf="imageWhatsapp > 5000000">Logo should be less than 5mb.</div>
                    </div> -->
                    <div *ngIf="embeddedSubmitted && !whatsappembeddedForm.controls.embeddedLogo.value[0]" class="invalid-feedback2">
                        <div style="color: #dc3545;">{{ 'WhatsppEmbedded.fbLogoRequired' | translate }}</div>
                        <div *ngIf="imageWhatsapp > 5000000" style="color: #dc3545;">{{ 'WhatsppEmbedded.fbLogoPatter' | translate }}</div>
                    </div>
                </div>
                <button type="button" class="col-md-1 col-xs-1 btn btn-default form-control headerTextEditorStyle" [popover]="logoTemplate" [placement]="'bottom'" [container]="'body'" [outsideClick]="true"> 
                    <em class="fas fa-info-circle"></em>
                </button>
            </div>
    
            <div class="form-group col-md-12 col-xs-12" style="display:inline-flex;padding:0px;">
                <div class="form-group col-md-4 col-xs-4" style="display:block;margin:auto;text-align: left;">
                    <label>{{ 'WhatsppEmbedded.status' | translate }}</label>
                </div>
                <div class="col-md-7 col-xs-7" style="padding-right:0px;">
                    <input type="text" formControlName="embeddedStatus" placeholder="Status" class="form-control" [ngClass]="{ 'is-invalid': embeddedSubmitted && e.embeddedStatus && e.embeddedStatus.errors }"/>
                    <div *ngIf="embeddedSubmitted && e.embeddedStatus && e.embeddedStatus.errors" class="invalid-feedback">
                        <div *ngIf="e.embeddedStatus.errors.required">{{ 'WhatsppEmbedded.statusRequired' | translate }}</div>
                        <div *ngIf="e.embeddedStatus.errors.maxlength">{{ 'WhatsppEmbedded.statusPattern' | translate }}</div>
                    </div>
                </div>
                <button type="button" class="col-md-1 col-xs-1 btn btn-default form-control headerTextEditorStyle" [popover]="statusTemplate" [placement]="'bottom'" [container]="'body'" [outsideClick]="true"> 
                    <em class="fas fa-info-circle"></em>
                </button>
            </div>
    
            <div class="form-group col-md-12 col-xs-12" style="display:inline-flex;padding:0px;">
                <div class="form-group col-md-4 col-xs-4" style="display:block;margin:auto;text-align: left;">
                    <label>{{ 'WhatsppEmbedded.Address' | translate }}</label>
                </div>
                <div class="col-md-7 col-xs-7" style="padding-right:0px;">
                    <textarea style="min-height:50px;max-height: 150px;" class="form-control" formControlName="embeddedAddress" placeholder="Address" [ngClass]="{ 'is-invalid':embeddedSubmitted && e.embeddedAddress && e.embeddedAddress.errors }"></textarea>
                    <div *ngIf="embeddedSubmitted && e.embeddedAddress && e.embeddedAddress.errors" class="invalid-feedback">
                        <div *ngIf="e.embeddedAddress.errors.required">{{ 'WhatsppEmbedded.AddressRequired' | translate }}</div>
                        <div *ngIf="e.embeddedAddress.errors.maxlength">{{ 'WhatsppEmbedded.AddressPattern' | translate }}</div>
                    </div>
                </div>
                <button type="button" class="col-md-1 col-xs-1 btn btn-default form-control headerTextEditorStyle" [popover]="addressTemplate" [placement]="'bottom'" [container]="'body'" [outsideClick]="true"> 
                    <em class="fas fa-info-circle"></em>
                </button>
            </div>
     
            <div class="form-group col-md-12 col-xs-12" style="display:inline-flex;padding:0px;">
                <div class="form-group col-md-4 col-xs-4" style="display:block;margin:auto;text-align: left;">
                    <label>{{ 'WhatsppEmbedded.Email' | translate }}</label>
                </div>
                <div class="col-md-7 col-xs-7" style="padding-right:0px;">
                    <input type="text" class="form-control" formControlName="embeddedEmail" placeholder="Email" [ngClass]="{ 'is-invalid':embeddedSubmitted && e.embeddedEmail && e.embeddedEmail.errors }" >
                    <div *ngIf="embeddedSubmitted && e.embeddedEmail && e.embeddedEmail.errors" class="invalid-feedback">
                        <div *ngIf="e.embeddedEmail.errors.required">{{ 'WhatsppEmbedded.EmailRequired' | translate }}</div>
                        <div *ngIf="e.embeddedEmail.errors.maxlength">{{ 'WhatsppEmbedded.EmailPattern' | translate }}</div>
                        <div *ngIf="!e.embeddedEmail.errors.required && e.embeddedEmail.errors.invalidEmail">{{ 'WhatsppEmbedded.EmailPattern2' | translate }}</div>
                    </div>
                </div>
                <button type="button" class="col-md-1 col-xs-1 btn btn-default form-control headerTextEditorStyle" [popover]="emailTemplate" [placement]="'bottom'" [container]="'body'" [outsideClick]="true"> 
                    <em class="fas fa-info-circle"></em>
                </button>
            </div>
             <div class="form-group col-md-12 col-xs-12" style="display:inline-flex;padding:0px;">
                <div class="form-group col-md-4 col-xs-4" style="display:block;margin:auto;text-align: left;">
                    <label>{{ 'WhatsppEmbedded.Website' | translate }}</label>
                </div>
                <div class="col-md-7 col-xs-7" style="padding-right:0px;">
                    <input type="text" class="form-control" formControlName="embeddedUrl" placeholder="Website URL" [ngClass]="{ 'is-invalid': embeddedSubmitted && e.embeddedUrl && e.embeddedUrl.errors }" >
                    <div *ngIf="embeddedSubmitted && e.embeddedUrl && e.embeddedUrl.errors" class="invalid-feedback">
                        <div *ngIf="e.embeddedUrl.errors.required">{{ 'WhatsppEmbedded.WebsiteRequired' | translate }}</div>
                        <div *ngIf="e.embeddedUrl.errors.maxlength">{{ 'WhatsppEmbedded.WebsitePattern' | translate }}</div>
                        <div *ngIf="!e.embeddedUrl.errors.required && e.embeddedUrl.errors.invalidUrl">{{ 'WhatsppEmbedded.WebsitePattern2' | translate }}</div>
                    </div>
                </div>
                <button type="button" class="col-md-1 col-xs-1 btn btn-default form-control headerTextEditorStyle" [popover]="addressTemplate" [placement]="'bottom'" [container]="'body'" [outsideClick]="true"> 
                    <em class="fas fa-info-circle"></em>
                </button>
            </div> 
            <div class="form-group col-md-12 col-xs-12" style="display:inline-flex;padding:0px;">
                <div class="form-group col-md-4 col-xs-4" style="display:block;text-align: left;">
                  <label>{{ 'WhatsppEmbedded.localStorage' | translate }}</label>
                </div>
                <div class="col-md-7 col-xs-7" style="padding-right:0px;">
                  <div ngbDropdown class="dropdown tclDisplayStyle">
                    <button type="button" class="btn btn-primary dropdown-toggle caret-off"
                      style="background-color: white;color: black;border-color: #bdbdbd;font-weight: 100;width:100%;box-shadow:none !important;"
                      id="wabaLocalStorageMenu" ngbDropdownToggle>
                      <span style="float:left;font-size: 1rem;font-weight: 400;">{{wabaLocalStorage.country}}</span>
                      <em class="fas fa-caret-down" style="margin-left: 5px;float:right;"></em>
                    </button>
                    <div style="max-height: 150px;overflow-y: scroll;padding:1% 3%;width: 100%;" class="dropdown-menu"
                      aria-labelledby="wabaLocalStorageMenu" ngbDropdownMenu>
                      <button type="button" style="font-weight: 100;background-color: white;border:none;" class="dropdown-item" *ngFor="let storage of wabaLocalStorageList"
                        (click)="changeSelectedStorage(storage)"
                        [ngClass]="{'selectedDropDownStyle' : wabaLocalStorage === storage.country}">
                        {{storage.country}}
                      </button>
                    </div>
                  </div>
                </div>
                <button type="button" class="col-md-1 col-xs-1 btn btn-default form-control headerTextEditorStyle"
                [popover]="localStoragePopover" [placement]="'bottom'" [container]="'body'" [outsideClick]="true">
                <em class="fas fa-info-circle"></em>
              </button>
              </div>
        
            <div class="form-group col-md-12 col-xs-12" style="display:inline-flex;padding:0px;">
                <div class="form-group col-md-4 col-xs-4" style="display:block;text-align: left;">
                    <label>{{ 'WhatsppEmbedded.ProcessedBy' | translate }}</label>
                </div>
                <div class="col-md-7 col-xs-7" style="padding-right:0px;padding-left: 35px; display:inline-flex;">
                    <div class="form-check form-check-inline" aria-labelledby="example-radio-group-label"  class="example-radio-group" [ngClass]="{ 'is-invalid':embeddedSubmitted && e.embeddedProcessedBy && e.embeddedProcessedBy.errors }" >
                    <input class="form-check-input" type="radio" name="embeddedProcessedBy" id="inlineRadio1" value="customer_server" formControlName="embeddedProcessedBy" (change)= "incommingEmbeddedMessageProcessed('customer_server')">
                    <label class="form-check-label" for="inlineRadio1">Customer Server</label>
                  </div>
                  <div class="form-check form-check-inline" style="padding-left: 40px"aria-labelledby="example-radio-group-label"  class="example-radio-group" [ngClass]="{ 'is-invalid':embeddedSubmitted && e.embeddedProcessedBy && e.embeddedProcessedBy.errors }">
                    <input class="form-check-input" type="radio" name="embeddedProcessedBy" id="inlineRadio2" value="unified_ai" formControlName="embeddedProcessedBy" (change)= "incommingEmbeddedMessageProcessed('unified_ai')">
                    <label class="form-check-label" for="inlineRadio2">Unified AI</label>
                  </div>
                  <div *ngIf="embeddedSubmitted && e.embeddedProcessedBy && e.embeddedProcessedBy.errors" class="invalid-feedback">
                    <div *ngIf="e.embeddedProcessedBy.errors.required">Select a value</div>
                </div>
          </div>  
             </div>
    
             <div *ngIf="showSetWebhook" class="form-group col-md-12 col-xs-12" style="display:inline-flex;padding:0px;">
                <div class="form-group col-md-4 col-xs-4" style="display:block;margin:auto;text-align: left;">
                    <label>{{ 'WhatsppEmbedded.Webhook' | translate }}</label>
                </div>
                <div class="col-md-7 col-xs-7" style="padding-right:0px;">
                    <input  type="text" class="form-control" formControlName="webhookurl" name="webhookurl"  (change)="webhookUrlChange()" placeholder="Webhook URL" [ngClass]="{ 'is-invalid': (embeddedSubmitted && e.webhookurl && e.webhookurl.errors)}"  >
                    <div *ngIf="!validWebhookUrl && embeddedSubmitted" class="invalid-feedback">
                        <div >{{ 'WhatsppEmbedded.WebhookRequired' | translate }}</div>
                    </div>
                </div>
                <button type="button" class="col-md-1 col-xs-1 btn btn-default form-control headerTextEditorStyle" [popover]="webhookTemplate" [placement]="'bottom'" [container]="'body'" [outsideClick]="true"> 
                    <em class="fas fa-info-circle"></em>
                </button>
            </div> 
            <div *ngIf="showSetWebhook" class="form-group col-md-12 col-xs-12" style="display:inline-flex;padding:0px;margin-bottom:0px;text-align: left !important;">
                <div class="form-group col-md-4 col-xs-4" style="display:block;">
                    <label>{{ 'WhatsppEmbedded.WebhookHeader' | translate }}</label>
                </div>
                <div class="row col-md-8 col-xs-8">
                    <div class="col-md-12 col-xs-12" style="padding: 0px;display: inline-flex;margin-bottom: 2%;">        
                        <div class="col-md-5 col-xs-5" style="padding-right:0px;">
                            <input  type="text" class="form-control" formControlName="headerKey" placeholder="Header Key(optional)">
                        </div>
                        <div class="col-md-5 col-xs-5" style="padding-right:0px;">
                            <input   type="text" class="form-control" formControlName="headerValue" placeholder="Header Value(optional)" >
                        </div>
                    </div>
                    <div class="col-md-12 col-xs-12" style="padding: 0px;display: inline-flex;margin-bottom: 2%;">
                        <div class="col-md-5 col-xs-5" style="padding-right:0px;">
                            <input type="text" class="form-control" formControlName="headerKey1" placeholder="Header Key(optional)">
                        </div>
                        <div class="col-md-5 col-xs-5" style="padding-right:0px;">
                            <input  type="text" class="form-control" formControlName="headerValue1" placeholder="Header Value(optional)" >
                        </div>
                    </div>
                    <div class="col-md-12 col-xs-12" style="padding: 0px;display: inline-flex;margin-bottom: 2%;">
                        <div class="col-md-5 col-xs-5" style="padding-right:0px;">
                            <input  type="text" class="form-control" formControlName="headerKey2" placeholder="Header Key(optional)">
                        </div>
                        <div class="col-md-5 col-xs-5" style="padding-right:0px;">
                            <input  type="text" class="form-control" formControlName="headerValue2" placeholder="Header Value(optional)" >
                        </div>
                        <div class="col-md-2 col-xs-2" style="display:inline-flex;padding-left:1%;">
                            <div (click)="webhookValidate()" class="btn btn-save" style="border-radius: 18px; color:white;background-color:#00417e;height:max-content;">
                                <span *ngIf="validateSpinner">
                                    <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>&nbsp; 
                                </span>  
                                <span>Validate</span>   
                                <!-- <span *ngIf="validateSpinner">Validating</span>                              -->
                            </div>
                            <em class="fa fa-check-circle" aria-hidden="true" style="color: #5dd65d;margin-left: 1%;padding:10%;" *ngIf="validWebhookUrl"></em>
                        </div>
                    </div>    
                </div>
            </div>  
    
            <!-- <div class="form-group col-md-12 col-xs-12" style="display:inline-flex;padding:0px;font-size:14px;text-align: left;">
                <div class="form-group col-md-4 col-xs-4" style="display:block;">
                </div>
                <div class="col-md-8 col-xs-8">
                    Download the <a href="https://ln5.sync.com/dl/50bc46060/jbd4xwuh-5vsjg4jc-mrbngkaj-7wmm4nmc" style="text-decoration:none;" target="_blank">Exhibit B</a> and <a href="https://ln5.sync.com/dl/8f81945e0/y3kf7m9a-cf3tex8q-3fmvsjqp-59s3k4ax" style="text-decoration:none;" target="_blank">Schedule 1</a> forms and upload them after filling in the details.
                </div>
            </div> 
            
             <div class="form-group col-md-12 col-xs-12" style="display:inline-flex;padding:0px;">
                <div class="form-group col-md-4 col-xs-4" style="display:block;margin:auto;text-align: left;">
                    <label>Exhibit B</label>
                </div>
                <div class="col-md-8 col-xs-8" style="padding-right:0px;display:inline-grid;">
                    <div style="display:inline-flex;">
                        <input type="file" placeholder="Exhibit B" [ngClass]="{ 'is-invalid': embeddedSubmitted && e.embeddedExihibitB && e.embeddedExihibitB.errors }" accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*" (change)="onFileEmbeddedChanged($event,'watsappEmbeddedexhibit')" style="border:none;padding-left:0px;width:70%;">
                        <img alt="" *ngIf="exhibitLoader && !responseExhibitembeddedURL" src="assets/images/uib-loading-500x500.gif" width="8%">

                    </div>
                    <div *ngIf="embeddedSubmitted && !responseExhibitembeddedURL" class="invalid-feedback2">
                        <div *ngIf="embeddedSubmitted && !responseExhibitembeddedURL" style="color: #dc3545;">Exhibit B is required</div>
                    </div>
                </div>
            </div>
    
            <div class="form-group col-md-12 col-xs-12" style="display:inline-flex;padding:0px;">
                <div class="form-group col-md-4 col-xs-4" style="display:block;margin:auto;text-align: left;">
                    <label>Schedule 1</label>
                </div>
                <div class="col-md-8 col-xs-8" style="padding-right:0px;display:inline-grid;">
                    <div style="display:inline-flex;">
                        <input type="file" placeholder="Schedule 1" [ngClass]="{ 'is-invalid': embeddedSubmitted && e.embeddedSchedule1 && e.embeddedSchedule1.errors }" accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf,image/*" (change)="onFileEmbeddedChanged($event,'watsappEmbeddedschedule')" style="border:none;padding-left:0px;width:70%;">
                        <img alt="" *ngIf="scheduleLoader && !responseScheduleEmbeddedURL" src="assets/images/uib-loading-500x500.gif" width="8%">
                    </div>
                    <div *ngIf="embeddedSubmitted && !responseScheduleEmbeddedURL" class="invalid-feedback2">
                        <div style="color: #dc3545;">Schedule 1 is required</div>
                    </div>
                </div>
            </div>  -->
            <div class="form-group " style="padding-bottom: 15px;">
                <button class="btn btn-default" style="border-radius: 18px;color:white;width: 200px;padding: 1%;"
                [style.background-color]="(whatsappembeddedForm.valid && responseImgEmbeddedURL && !showFbLoginLoader && (validWebhookUrl || !showSetWebhook))? '#1e87f0':'#595a5f' " 
                (click)="whatsappembeddedForm.valid && responseImgEmbeddedURL && (validWebhookUrl || !showSetWebhook)? fblogin() : embeddedSubmitted= true">
                {{ 'WhatsppEmbedded.fbLogin' | translate }}</button> 

                <section *ngIf="showFbLoginLoader" class="example-section">
                <h4  style="margin-top: 15px;">{{ 'WhatsppEmbedded.fbLoginInfo' | translate }}
                </h4>
                    <mat-progress-bar
                        class="example-margin"
                        [color]="color"
                        [mode]="mode"
                        [value]="value"
                        [bufferValue]="bufferValue">
                    </mat-progress-bar>
                </section>
            </div> 
    </form>
        </div>
    </div>

</div> 
<ng-template #webhookTemplate>
    <p style="font-size:12px;margin-bottom: 0px !important;">{{ 'WhatsppEmbedded.webhookPop1' | translate }}</p>
    <br/>                    
    <p style="font-size:12px;margin-bottom: 0px !important;">{{ 'WhatsppEmbedded.webhookPop2' | translate }}</p>
    <br/>
    <p style="font-size:12px;margin-bottom: 0px !important;">{{ 'WhatsppEmbedded.webhookPop3' | translate }}</p>
    <p style="font-size:12px;margin-bottom: 0px !important;display:inline-grid;">
        <label style="margin-bottom: 0px !important;">{{'{'}}</label>
        <label style="margin-bottom: 0px !important;">status: 200,</label>
        <label style="margin-bottom: 0px !important;">info: 'OK'</label>
        <label style="margin-bottom: 0px !important;">{{'}'}}</label>
    </p>
</ng-template>
<ng-template #statusTemplate>
    <p style="font-size:12px;margin-bottom: 0px !important;">{{ 'WhatsppEmbedded.statusPop' | translate }}</p>
</ng-template>

<ng-template #addressTemplate>
    <p style="font-size:12px;margin-bottom: 0px !important;">Maximum of 256 characters</p>
</ng-template>
<ng-template #logoTemplate>
    <p style="font-size:12px;margin-bottom: 0px !important;">640px x 640px (max 5MB)</p>
</ng-template>
<ng-template #emailTemplate>
    <p style="font-size:12px;margin-bottom: 0px !important;">Maximum of 128 characters</p>
</ng-template>
<ng-template #managerIdTemplate>
    <p style="font-size:12px;margin-bottom: 0px !important;">If you don’t have one, create it at <a href="https://business.facebook.com" style="text-decoration:none;" target="_blank">https://business.facebook.com</a>
    </p>
</ng-template>
<ng-template #localStoragePopover>
    <p style="font-size:12px;margin-bottom: 0px !important;">Cloud API Local Storage gives you the option to control where your message data is stored at rest. <a
      href="https://developers.facebook.com/docs/whatsapp/cloud-api/overview/local-storage/"
      target="_blank"><u>https://developers.facebook.com/docs/whatsapp/cloud-api/overview/local-storage/</u></a></p>
  </ng-template>
  